"use client";
import { Img } from "react-image";
import { useState } from "react";
import styles from "../../css/FilterableCards.module.css";
import icons from "../../css/icons.module.css";
import { motion, AnimatePresence } from 'framer-motion';
const cardsData = [
  {
    id: 1,
    title: "Ejercicios Java",
    url: "https://exercises-js-psi.vercel.app/excuses.html",
    description: "Lista de ejercicios JavaScript ",
    picture: "img/javaScript.jpg",
    tags: ["frontend", "javascript"],
  },
  {
    id: 2,
    title: "4teach Parents",
    url: "https://4teach-parents.vercel.app/",
    description: "Guía cuidado de niños menores de 5 años.",
    picture: "img/4teachParents.png",
    tags: ["frontend", "react"],
  },
  {
    id: 3,
    title: "Coffee Agro",
    url: "https://github.com/JKalith/CoffeeAgro",
    description: "Gestor de productos para un cafetal",
    picture: "  img/coffeAgro.jpg",
    tags: ["backend", "react", "javascript", "frontend"],
  },

  {
    id: 4,
    title: "Nature Tours",
    url: "https://naturetourscostarica.com/",
    description: "Página para reservación de tours ",
    picture: "  img/natureTours.jpg",
    tags: ["worpress"],
  },
  
];

export default function FilterableCards() {
  const [searchTag, setSearchTag] = useState("");

  const filteredCards = searchTag
    ? cardsData.filter((card) => card.tags.includes(searchTag.toLowerCase()))
    : cardsData;

  return (
    <div className={styles.container}>
      <div className={styles.containerFlexB}>
        <div className={styles.tagsContainer}>
          {[...new Set(cardsData.flatMap((card) => card.tags))].map((tag) => (
            <button
              key={tag}
              className={`${styles.tagButton} ${
                searchTag === tag ? styles.active : ""
              }`}
              onClick={() =>
                setSearchTag((prevTag) => (prevTag === tag ? "" : tag))
              }
            >
              {tag}
            </button>
          ))}
        </div>

<a href="
https://github.com/JKalith

">
<button className={styles.btnGit}> Mi Github </button>

</a>


      </div>

      <div className={styles.cardsGrid}>
  <AnimatePresence>
    {filteredCards.map((card) => (
      <motion.a
        key={card.id}
        target="_blank"
        className={styles.label}
        href={card.url}
        layout
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className={styles.card}>
          <p className={styles.cardTitle}>{card.title}</p>
          <div className={styles.imgContainer}>
            <Img
              className={styles.imgStyle}
              src={card.picture}
              loader={<p>Loading...</p>}
              unloader={<p>Not found</p>}
            />
          </div>
          <p className={styles.cardDescription}>{card.description}</p>
        </div>
      </motion.a>
    ))}
  </AnimatePresence>
</div>

      <div className={styles.flexBetween}>
        <div className={styles.stackBar}>
          <p className={styles.titleBar}>My stack</p>
          <div className={styles.containerStack}>
            
            <div className={icons.figma}>
               
            </div>

            <div className={icons.gitHub}></div>

            <div className={icons.nextJs}></div>
            <div className={icons.wordpress}></div>
          </div>
        </div>
        <div className={styles.infoBar}>
          <p className={styles.titleBar}>
          ¿Quieres saber más de mí?</p>


     
   
          <a className={styles.buttonCv} href="https://www.linkedin.com/in/jkalith/">

          <button className={styles.btnCv}>
            
          Visita mi linkedin</button>
            </a>
        


        </div>
      </div>
    </div>
  );
}
